import allSteps from '../all-steps';
import minervaForm from 'minerva-form';


$(document).ready(function() {
  function toggleCheckbox() {
      let selectedCycle = $('input[name="application_cycle"]:checked').val();
      let checkbox = $("#id_has_indicated_high_interest_in_attending");
      if (selectedCycle === "Early Action") {
          checkbox.iCheck("enable");
          checkbox.prop("disabled", false);
      } else {
          checkbox.iCheck("uncheck");
          checkbox.iCheck("disable");
          checkbox.prop("disabled", true);
      }
  }

  toggleCheckbox();

  $('input[name="application_cycle"]').on('ifChecked', function() {
      toggleCheckbox();
  });
});

$(function () {
  let $applicationCycle = $(".application_cycle"),
      $bindingEnrollment = $(".binding_enrollment_choice"),
      currentAppTerm = $('meta#current_app_term').attr("content"),
      isVsyApp = $('meta#is_vsy_app').attr('content') == 'true';

  if (isVsyApp) {
    $(".matriculation_date").hide();
    $bindingEnrollment.hide();
  }

  if ($applicationCycle) {
    if ($("input[name=matriculation_date]:checked").val() === currentAppTerm) {
      $applicationCycle.show();
    } else {
      $applicationCycle.hide();
    }

    $("input[name=matriculation_date]").on('ifChecked', function(e){
      if (e.target.value == currentAppTerm) {
        $applicationCycle.slideDown();
      } else {
        $applicationCycle.slideUp();
      }
    });
  }

  let displaySource = function(e) {
    const source = $("#id_source").val();
    if(source === "Other" || source === "Minerva Student") {
      $(".source-other").slideDown();
    } else {
      $(".source-other").slideUp();
    }
  }
  displaySource();
  $("#id_source").change(displaySource);

  let $wasPreviouslyAdmitted = $('.js-was-previously-admitted');
  let $hasPreviouslyApplied = $("input[name=has_previously_applied]");
    $hasPreviouslyApplied.on('ifChecked', function(e){
        if (e.target.value === 'True') {
          $wasPreviouslyAdmitted.slideDown();
        } else {
          $wasPreviouslyAdmitted.slideUp();
        }
    });
});



// WEBPACK FOOTER //
// client/application/step1/bundle.js